import { call, put, takeLatest, take } from "redux-saga/effects";
import { eventChannel } from "redux-saga";
import {
  RECEIVE_LABELS_LIST_REQUEST,
  RECEIVE_TAGS_LIST_REQUEST,
  UPDATE_TAG_REQUEST,
  DELETE_TAG_REQUEST,
  UPDATE_LABEL_REQUEST,
  DELETE_LABEL_REQUEST,
  CREATE_NEW_LABEL_REQUEST,
  CREATE_NEW_TAG_REQUEST,
  GET_GOOGLE_DRIVE_REQUEST,
  DISCONNECT_GOOGLE_DRIVE_REQUEST,
  CHECK_DRIVE_CONNECTION_REQUEST,
} from "../../../common/constants/action-constants";
import ApiService from "../../../common/services/api.service";
import {
  receiveLabelsListError,
  receiveLabelsListSuccess,
  receiveTagsListError,
  receiveTagsListSuccess,
  updateTagError,
  receiveTagsListRequest,
  deleteTagError,
  receiveLabelsListRequest,
  updateLabelError,
  deleteLabelError,
  createNewLabelError,
  createNewTagError,
  disconnectDriveSuccess,
  disconnectDriveError,
  checkGoogleDriveConnectionSuccess,
  checkGoogleDriveConnectionError,
  // connectToDriveSuccess,
  connectToDriveError,

} from "../actions";
import AlertService from "../../../common/services/notification.service";
import { notificationMessage } from "../../../common/constants/notication-constants";
import UserService from '../../../common/services/user.service';
import axios from "axios";

type ErrorResponse = {
  status?: string;
  statusCode?: number;
  error?: string;
}

function createMessageChannel() {
  return eventChannel(emitter => {
    const messageHandler = (event: MessageEvent) => {
      if (event.data  && typeof event.data.success === "boolean") {
        emitter(event.data)
        }
      }
    window.addEventListener("message", messageHandler)
    return () =>
      window.removeEventListener("message", messageHandler)
  })
}

function* getLabelsList(_action: { type: string }) {
  try {
    const labelsList = yield call(ApiService.get, "/labels");
    if (labelsList) {
      yield put(receiveLabelsListSuccess(labelsList.data));
    }
  } catch (e) {
    yield put(receiveLabelsListError(e));
  }
}

function* updateLabel(action: { id: number; name: { name: string}; type: string }) {
  try {
    const response = yield call(
      ApiService.put,
      `/label/${action.id}`,
      action.name
    );
    const message = response?.data?.message;
    if (message === notificationMessage.LABEL_UPDATE_SUCCESS) {
      AlertService.success(message);
      yield put(receiveLabelsListRequest());
    } else {
      AlertService.error(message || notificationMessage.BASE_ERROR_MESSAGE);
      yield put(updateLabelError(message));
    }
  } catch (error) {
    yield put(updateLabelError(error));
    AlertService.error(notificationMessage.BASE_ERROR_MESSAGE);
  }
}

function* deleteLabel(action: { id: string; type: string }) {
  try {
    const response = yield call(ApiService.delete, `/label/${action.id}`);
    const message = response?.data?.message;
    if (message === notificationMessage.LABEL_DELETE_SUCCESS) {
      AlertService.success(message);
      yield put(receiveLabelsListRequest());
    } else {
      AlertService.error(message || notificationMessage.BASE_ERROR_MESSAGE);
      yield put(deleteLabelError(message));
    }
  } catch (error) {
    yield put(deleteLabelError(error));
    AlertService.error(notificationMessage.BASE_ERROR_MESSAGE);
  }
}

function* createLabel(action: { type: string; payload: { name: string }}) {
  try {
    // const response = yield call(ApiService.post, "/label", {name: ""}, { skipGlobalError: true});
    const response = yield call(() => ApiService.post("/label",action.payload, { skipGlobalError: true}));
    AlertService.success(response.data?.message);
    yield put(receiveLabelsListRequest());
  } catch (error: unknown) {
    if (axios.isAxiosError(error)) {
      const data = error.response?.data as ErrorResponse | undefined;
      const statusCode = error.response?.status ?? data?.statusCode;
      if (statusCode === 409) {
        AlertService.error(data?.error ?? "Label already exists");
      } else if (statusCode === 400) {
        AlertService.error(data?.error ?? "Label name must not be empty");
      } else {
        AlertService.error(notificationMessage.BASE_ERROR_MESSAGE);
      }
      yield put(createNewLabelError(error));
      return;
    }
    yield put(createNewLabelError(error));
    AlertService.error(notificationMessage.BASE_ERROR_MESSAGE);
  }
}

function* getTagsList(_action: { type: string }) {
  try {
    const tagsList = yield call(ApiService.get, "/tags");
    if (tagsList) {
      yield put(receiveTagsListSuccess(tagsList.data));
    }
  } catch (e) {
    yield put(receiveTagsListError(e));
  }
}

function* updateTag(action: { id: number; name: { name: string }; type: string }) {
  try {
    const response = yield call(ApiService.put, `/tag/${action.id}`, action.name);
    const message = response?.data?.message;
    if (message === notificationMessage.TAG_UPDATE_SUCCESS) {
      AlertService.success(message);
      yield put(receiveTagsListRequest());
    } else {
      AlertService.error(message || notificationMessage.BASE_ERROR_MESSAGE);
      yield put(updateTagError(message))
    }
  } catch (error) {
    yield put(updateTagError(error));
    AlertService.error(notificationMessage.BASE_ERROR_MESSAGE);
  }
}

function* deleteTag(action: { id: string; type: string }) {
  try {
    const response = yield call(ApiService.delete, `/tag/${action.id}`);
    const message = response?.data?.message;
    if (message === notificationMessage.TAG_DELETE_SUCCESS) {
      AlertService.success(message);
      yield put(receiveTagsListRequest());
    } else {
      AlertService.error(message || notificationMessage.BASE_ERROR_MESSAGE);
      yield put(deleteTagError(message))
    }
  } catch (error) {
    yield put(deleteTagError(error));
    AlertService.error(notificationMessage.BASE_ERROR_MESSAGE);
  }
}

function* createTag(action: { type: string; payload: { name: string }}) {
  try {
    // const response = yield call(ApiService.post, "/tag", action.payload);
    const response = yield call(() => ApiService.post("/tag", action.payload, { skipGlobalError: true}));
    AlertService.success(response.data.message);
    yield put(receiveTagsListRequest());
  } catch (error: unknown) {
    if (axios.isAxiosError(error)) {
      const data = error.response?.data as ErrorResponse | undefined;
      const statusCode = error.response?.status ?? data?.statusCode;
      if (statusCode === 409) {
        AlertService.error(data?.error ?? "Tag already exists");
      } else if (statusCode === 400) {
        AlertService.error(data?.error ?? "Tag name must not be empty");
      } else {
        AlertService.error(notificationMessage.BASE_ERROR_MESSAGE);
      }
      yield put(createNewTagError(error));
      return;
    }
    yield put(createNewTagError(error));
    AlertService.error(notificationMessage.BASE_ERROR_MESSAGE);
  }
}

function* driveConnect(_action: { type: string }) {
  try {
    const origin = encodeURIComponent(window.location.origin);
    const driveAuthUrl = yield call(ApiService.get, `/user/drive/auth?origin=${origin}`);
    if (driveAuthUrl) {
      const windowWidth = 800;
      const windowHeight = 600;
      let mainWidth =
        document.documentElement.clientWidth / 2 - windowWidth / 3;
      let mainHeight =
        document.documentElement.clientHeight / 2 - windowHeight / 4;
      const popup = window.open(
        driveAuthUrl.data.authUrl,
        "google-oauth",
        `width=${windowWidth},height=${windowHeight}, top=${mainHeight}, left=${mainWidth}`
      );

      const channel = yield call(createMessageChannel);

      if (!popup) {
        AlertService.error("Failed to open authorization window");
        channel.close();
        return;
      }
      const { success } = yield take(channel);
      if (success) {
          yield put(checkGoogleDriveConnectionSuccess({connection: true}))
      } else {
          yield put(checkGoogleDriveConnectionSuccess({connection: false}))
      }
      channel.close();
    }
  } catch (error) {
    yield put(connectToDriveError(error));
    // console.log(error);
  }
}

function* driveDisconnect(_action: { type: string }) {
  try {
    const result = yield call(ApiService.delete, "/user/drive/auth");
    if (result?.data?.connectionRemoved) {
      AlertService.success("You successfully disconnected from Randvast G-suite.");
      yield put(disconnectDriveSuccess(result.data));
    } else {
      AlertService.error("Something went wrong while trying to disconnect.");
    }
  } catch (error) {
    AlertService.error("Something went wrong while trying to disconnect.");
    yield put(disconnectDriveError(error));
  }
}

function* driveConnectionCheck(_action: { type: string }) {
  try {
    if (!UserService.token) return;
    const result = yield call(ApiService.get, "/user/drive/check");
    if (result) {
      yield put(checkGoogleDriveConnectionSuccess(result.data));
    }
  } catch (error: any) {
    yield put(checkGoogleDriveConnectionError(error));
  }
}

export default function* actionSuperAdmin() {
  yield takeLatest(RECEIVE_LABELS_LIST_REQUEST, getLabelsList);
  yield takeLatest(RECEIVE_TAGS_LIST_REQUEST, getTagsList);
  yield takeLatest(UPDATE_LABEL_REQUEST, updateLabel);
  yield takeLatest(DELETE_LABEL_REQUEST, deleteLabel);
  yield takeLatest(UPDATE_TAG_REQUEST, updateTag);
  yield takeLatest(DELETE_TAG_REQUEST, deleteTag);
  yield takeLatest(CREATE_NEW_LABEL_REQUEST, createLabel);
  yield takeLatest(CREATE_NEW_TAG_REQUEST, createTag);
  yield takeLatest(GET_GOOGLE_DRIVE_REQUEST, driveConnect);
  yield takeLatest(DISCONNECT_GOOGLE_DRIVE_REQUEST, driveDisconnect);
  yield takeLatest(CHECK_DRIVE_CONNECTION_REQUEST, driveConnectionCheck);
}
